import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { clinic } from "@/data/clinic";

interface LegalPageProps {
  eyebrow: string;
  title: string;
  intro: string;
  children: ReactNode;
}

export default function LegalPage({ eyebrow, title, intro, children }: LegalPageProps) {
  return (
    <>
      <section className="bg-background-100 border-b border-background-200 px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-content mx-auto">
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="hover:text-primary-600 cursor-pointer">
              Home
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-700">{eyebrow}</span>
          </nav>
          <h1 className="mt-6 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
            {title}
          </h1>
          <p className="mt-4 text-base leading-relaxed text-foreground-600 max-w-2xl">{intro}</p>
        </div>
      </section>

      <section className="bg-background-50 px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl border border-background-200 bg-background-50 p-6 md:p-8 space-y-6 text-sm md:text-base leading-relaxed text-foreground-700">
            {children}
            <div className="pt-6 border-t border-background-200">
              <p className="text-sm text-foreground-600">
                For questions about this page, contact {clinic.brand} at{" "}
                <a
                  href={clinic.phoneHref}
                  className="font-medium text-primary-700 hover:text-primary-600 cursor-pointer"
                >
                  {clinic.phone}
                </a>{" "}
                or{" "}
                <a
                  href={`mailto:${clinic.email}`}
                  className="font-medium text-primary-700 hover:text-primary-600 cursor-pointer"
                >
                  {clinic.email}
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}